<div *transloco="let t" class="flex flex-col gap-6 items-center justify-center h-screen px-4">
  <pxc-loader [status]="(isStatusChecking$ | async) ? Status.LOADING : Status.ERROR" [useLogo]="true" />

  <h1 class="text-center">
    {{ t('Service indisponible') }}
  </h1>
  <p class="text-center text-balance">
    {{ t('Veuillez nous excuser pour la gêne occasionnée.') }}
    <br />
    {{ t('Merci de réessayer dans quelques instants.') }}
  </p>
  <button appearance="primary" size="l" tuiButton [loading]="isStatusChecking$ | async" (click)="retryConnection()">
    {{ t('Réessayer') }}
  </button>
</div>
